import { render, staticRenderFns } from "./amountDailog.vue?vue&type=template&id=1b720f0e&scoped=true&"
import script from "./amountDailog.vue?vue&type=script&lang=js&"
export * from "./amountDailog.vue?vue&type=script&lang=js&"
import style0 from "./amountDailog.vue?vue&type=style&index=0&id=1b720f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b720f0e",
  null
  
)

export default component.exports